import React, {useEffect} from 'react';
import {Link, useLocation} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import {useAuth} from "../../../context/AuthContext";
import {customEncodeURIComponent} from "../../utils/utils";

const MainNav = ({partner, tripTypes, destinations}) => {
    const auth = useAuth();
    const location = useLocation();

    // Call fetchData on component mount
    useEffect(() => {

    }, []);

    // close Mobile nav
    const offCanvas = document.getElementById('offcanvasNavbar2');
    if (offCanvas) {
        const close = document.getElementById('closeOffCanvas');
        const aElements = document.querySelectorAll(".offcanvas-body a");
        aElements.forEach(function (elem) {
            elem.addEventListener("click", function () {
                close.click();
            });
        });
        /*offCanvas.addEventListener("click", e => {
            close.click();
        })*/
    }

    return (
        <header id="masthead" className="site-header sticky_header affix-top">
            <div className="" id="banner">
                <nav id="navscroll"
                     className="navbar navbar-expand-lg navbar-light bg-light " aria-label="Offcanvas navbar large">
                    <div className="container-fluid container-xxl">
                        <div className="d-xl-none d-md-none d-sm-block">
                            <a className="navbar-brand" href={`${process.env.PUBLIC_URL}/`}>
                                <img src={`${process.env.REACT_APP_LOGOS_PATH}/${partner.header_logo}`}
                                     alt={partner.name}
                                     title={partner.name}
                                     className="img-logo"/>
                            </a>
                        </div>
                        <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2"
                                aria-label="Navigation anzeigen"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="offcanvas offcanvas-end " tabIndex="-1"
                             id="offcanvasNavbar2">

                            <div className="offcanvas-header">
                                <button type="button" className="btn-close btn-close-white"
                                        data-bs-dismiss="offcanvas" id="closeOffCanvas" aria-label="Close"></button>
                            </div>

                            <div className="offcanvas-body justify-content-center" id="navbarSupportedContent">
                                <ul className="navbar-nav  ">
                                    <li className={`${location.pathname === "/" ? "current-menu-ancestor" : ""}`}>
                                        <Link className="nav-link" to="/">Home</Link>
                                    </li>
                                    <li className={`${location.pathname === "/reisekalender" ? "current-menu-ancestor" : ""}`}>
                                        <Link className="nav-link" to="/reisekalender">Reisekalender</Link>
                                    </li>
                                    <li className={`menu-item-has-children ${location.pathname.includes("/reiseziele") ? "current-menu-ancestor" : ""}`}>
                                        <Link className="nav-link" to="/reiseziele">Reiseziele</Link>
                                        <ul className="sub-menu">
                                            {destinations?.map((post, x) => (
                                                <li key={x}>
                                                    <Link className="nav-link"
                                                          to={'/reiseziele/' + customEncodeURIComponent(post.Kontinent_2012) + '?kontinent=' + post.ID}>{post.Kontinent_2012}</Link>
                                                </li>
                                            ))}
                                            <li>
                                                <Link className="nav-link" to="/reisefinder">Alle Reisen</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className={`menu-item-has-children ${location.pathname.includes("/reisearten") ? "current-menu-ancestor" : ""}`}>
                                        <Link className="nav-link" to="/reisearten">Reisearten</Link>
                                        <ul className="sub-menu">
                                            {tripTypes?.map((post, i) => (
                                                <li key={i}>
                                                    <Link className="nav-link"
                                                          to={`/reisearten/` + customEncodeURIComponent(post.title) + `?type=${post.id}`}>{post.title}</Link>
                                                </li>
                                            ))}
                                            <li>
                                                <Link className="nav-link" to="/reisefinder">Alle Reisen</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className={`menu-item-has-children ${location.pathname.includes("/informationen") ? "current-menu-ancestor" : ""}`}>
                                        <a href="#" className="nav-link"> Informationen </a>
                                        <ul className="sub-menu">
                                            <li>
                                                <Link className="nav-link" to="/karriere">Karriere</Link>
                                            </li>
                                            <li><Link className="nav-link"
                                                      to="/informationen/rkv">Reiseversicherungen</Link></li>
                                            <li><Link className="nav-link"
                                                      to="/informationen/reisebedingungen">Reisebedingungen</Link>
                                            </li>
                                            <li><Link className="nav-link"
                                                      to="/informationen/zahlungsweisen">Zahlungsweisen</Link></li>
                                            <li><HashLink className="nav-link"
                                                          to="informationen/reisebedingungen#Storno">Stornogebühren</HashLink>
                                            </li>
                                            <li><Link className="nav-link" to="/informationen/faq">Oft gestellte
                                                Fragen</Link></li>
                                        </ul>
                                    </li>
                                    <li className={`${location.pathname === "/globalis" ? "current-menu-ancestor" : ""}`}>
                                        <Link className="nav-link" to="/globalis">Über Globalis</Link>
                                    </li>
                                    <li className={`${location.pathname === "/kontakt" ? "current-menu-ancestor" : ""}`}>
                                        <Link className="nav-link"
                                              to={`${process.env.PUBLIC_URL}/kontakt/`}>Kontakt</Link>
                                    </li>
                                    {/* {auth.user &&
                                            <li className={`menu-item-has-children ${location.pathname.includes("/dashboard") ? "current-menu-ancestor" : ""}`}>
                                                <a href="#"><i className="fa fa-user"></i> Konto </a>
                                                <ul className="sub-menu">
                                                    <li><Link to="/dashboard">Dashboard</Link></li>
                                                    <li><Link to="/logout"><i
                                                        className="fa fa-sign-out"></i>Logout</Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        }*/}
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default MainNav;